import React from 'react';
import { CustomDropdown, CustomDatePicker } from '../common/index.js';
import { todayCalendarDate } from '../utils/calendarDate.js';

const InsightsFilterBar = ({
  consultationProcessingTimeDropdown,
  customDateRange,
  dateRange,
  dateRangeDropdown,
  dateRangeOptions,
  documentsReadyDropdown,
  handleCustomDateChange,
  handleDateRangeSelect,
  handleViewModeChange,
  processingTimeDropdown,
  showUserCharts,
  viewMode
}) => (
  <>
        <div className="filter-bar">
          {dateRange.value === 'custom' && (
            <div className="custom-date-inputs">
              <CustomDatePicker
                value={customDateRange.from}
                onChange={(value) => handleCustomDateChange('from', value)}
                label="From"
                max={customDateRange.to}
              />
              <CustomDatePicker
                value={customDateRange.to}
                onChange={(value) => handleCustomDateChange('to', value)}
                label="To"
                min={customDateRange.from}
                max={todayCalendarDate()}
              />
            </div>
          )}
          <CustomDropdown
            options={dateRangeOptions}
            selectedOption={dateRangeDropdown.selected.display}
            onSelect={handleDateRangeSelect}
            isOpen={dateRangeDropdown.isOpen}
            toggleDropdown={() => dateRangeDropdown.toggle([documentsReadyDropdown, processingTimeDropdown, consultationProcessingTimeDropdown])}
            keyExtractor={(option, index) => `date-range-${option.value || index}`}
          />
          {showUserCharts && (
            <div className="view-mode-switch">
              <button
                className={`view-mode-tab ${viewMode === 'gp-practice' ? 'active' : ''}`}
                onClick={() => handleViewModeChange('gp-practice')}
              >
                GP Practice
              </button>
              <button
                className={`view-mode-tab ${viewMode === 'staff' ? 'active' : ''}`}
                onClick={() => handleViewModeChange('staff')}
              >
                Staff
              </button>
            </div>
          )}
        </div>
  </>
);

export default InsightsFilterBar;
